import { ConsultationSessionState } from './i-combined-conversation.response';

export function isConsultationSessionInProgress(state: ConsultationSessionState | null | undefined): boolean {
  return [
    ConsultationSessionState.Starting,
    ConsultationSessionState.Ongoing,
    ConsultationSessionState.PutOnHold,
    ConsultationSessionState.Conferenced,
  ].includes(state);
}
